import { createStore } from 'vuex';
import loader from '@/app/store/loader';
import projectsMap from '@/app/store/projects-map';

export default createStore({
  strict: process.env.NODE_ENV === 'development',
  modules: {
    loader,
    projectsMap,
  },
});
